<template>
    <LaborLogsTable></LaborLogsTable>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const LaborLogsTable = defineAsyncComponent(() =>
    import("../../components/DPAM_PunchSystem/LaborLogs/Table.vue")
);

export default {
    name: "DPAM_Labor_Logs", //The name you are in should not equal the name of the component you are importing.
    components: { LaborLogsTable, AuthLayout },
};
</script>
